import { ReactNode } from "react";
import { Box, Paper, Skeleton, Typography } from "@mui/material";
import { analyticsTheme, cardSx } from "../theme";

interface AnalyticsKpiCardProps {
  label: string;
  value: string;
  icon: ReactNode;
  accent: { main: string; soft: string };
  isLoading?: boolean;
  testId?: string;
}

export const AnalyticsKpiCard = ({
  label,
  value,
  icon,
  accent,
  isLoading,
  testId,
}: AnalyticsKpiCardProps) => (
  <Paper
    elevation={0}
    sx={{
      ...cardSx,
      p: 2.75,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 2,
      position: "relative",
      overflow: "hidden",
      "&:hover": {
        boxShadow: analyticsTheme.shadow.cardHover,
        borderColor: analyticsTheme.borderStrong,
        transform: "translateY(-2px)",
      },
    }}
    data-testid={testId}
  >
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: 3,
        background: `linear-gradient(90deg, ${accent.main}, ${accent.main}00)`,
      }}
    />

    <Box
      sx={{
        width: 44,
        height: 44,
        borderRadius: analyticsTheme.radius.sm,
        backgroundColor: accent.soft,
        color: accent.main,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& svg": { fontSize: 24 },
      }}
    >
      {icon}
    </Box>

    <Box>
      <Typography
        sx={{
          fontSize: 12.5,
          fontWeight: 600,
          letterSpacing: 0.4,
          textTransform: "uppercase",
          color: analyticsTheme.text.muted,
          mb: 0.75,
        }}
      >
        {label}
      </Typography>
      {isLoading ? (
        <Skeleton variant="text" width="55%" height={44} />
      ) : (
        <Typography
          component="p"
          sx={{
            fontSize: { xs: 28, sm: 32 },
            lineHeight: 1.1,
            fontWeight: 700,
            color: analyticsTheme.text.primary,
            letterSpacing: -0.5,
          }}
        >
          {value}
        </Typography>
      )}
    </Box>
  </Paper>
);
